module.exports = __webpack_public_path__ + "img/x-Bq.68989f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/x-Bq.jpg
// module id = q6lf
// module chunks = 1